import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": ""
}
const pinUserDataSlice = createSlice({
    name:'pinUserDataSlice',
    initialState,
    reducers:{
        pinUserData: (_state,payload)=>{
                return{
                    ..._state,
                    "id": uuidv4(),
                    "data": {userJid:payload.payload}
                }
        }
    }
});

export default pinUserDataSlice.reducer
export const pinUserData = pinUserDataSlice.actions.pinUserData
